import React from 'react'
import '../Page.css'
import EditCategory from '../../Components/CategoriesPageComponents/EditCategory/EditCategory'

const Categories = () => {
  return (
    <div className="HomePage" style={{ gap: '20px' }}>
      <EditCategory />
    </div>
  )
}

export default Categories